import { Controller, type Control } from "react-hook-form";
import {ProgramStudentModuleTechniqueType,} from "../../../../types/dto/program";
import { Select } from "antd";
import { selectUser } from "../../../../redux";
import { useSelector } from "react-redux";
 
export default function EditStudentQualificationForm({
  control,
}: {
  control?: Control<ProgramStudentModuleTechniqueType>;
}) {
  const user = useSelector(selectUser);

  return (
    <div className="flex flex-col gap-3">
       {
        user?.role && ["teacher", "teacher_admin", "admin"].includes(user?.role) && (
          <Controller
          control={control}
          name="qualification_check"
          render={({ field, fieldState }) => (
            <div>
              <label>Estado de la calificación</label>
              <Select
                {...field}
                showSearch
                style={{ width: 270 }}
                placeholder="Selecciona el estado"
                optionFilterProp="label"
                defaultValue={field.value}
                options={ [
                        {
                          value: "approved",
                          label: "Aprobado",
                        },
                        {
                          value: "disapproved",
                          label: "Reprobado",
                        },
                      ]
                }
              />
              {fieldState.error ? (
                <span className="mt-1 block text-xs text-red-500">
                  {fieldState.error.message}
                </span>
              ) : null}
            </div>
          )}
        />
        )
      }
    </div>
  );
}
